<span class="x-badge" [class]="'x-badge--' + color">
  <ng-content></ng-content>
</span>

